package com.vizio.redwolf.consent.api

import com.vizio.redwolf.consent.model.ConsentClientResponse
import com.vizio.redwolf.consent.model.ConsentReceiptResponse
import com.vizio.redwolf.consent.model.SaveUserConsentV2ProxyRequestInfo
import com.vizio.redwolf.consent.model.UserConsentV2DataRequestInfo
import com.vizio.redwolf.consent.model.UserConsentV2ProxyStatusRequestInfo
import com.vizio.redwolf.consent.model.UserConsentV2Response
import com.vizio.redwolf.utils.model.ConnectionConfig

interface ConsentV2FusedApiInterface {
    suspend fun requestConsentData(requestInfo: UserConsentV2DataRequestInfo, connectionConfig: ConnectionConfig? = null, traceId: String? = null): ConsentResult<ConsentClientResponse>
    suspend fun requestUserConsentStatus(requestInfo: UserConsentV2ProxyStatusRequestInfo, connectionConfig: ConnectionConfig? = null, traceId: String? = null): ConsentResult<UserConsentV2Response>
    suspend fun saveUserConsent(requestInfo: SaveUserConsentV2ProxyRequestInfo, connectionConfig: ConnectionConfig? = null, traceId: String? = null): ConsentResult<ConsentReceiptResponse>
}